/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Xmlid7347IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Xmlid7347Icon(props: Xmlid7347IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 121 543"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M109.47 533.71c-2.198 6.939-9.905 10.448-16.593 7.588l-13.122-5.615c.331-.622.597-1.285.821-1.974 10.064-31.674 28.814-116.554-26.152-194.934-28.616-40.797-19.505-64.964-2.953-108.808 6.766-17.943 14.447-38.282 19.373-61.231 9.19-42.691-4.356-86.92-39.157-127.943C20.644 27.79 9.242 17.169 0 9.409l2.556-3.866c3.946-5.998 12.17-7.349 17.85-2.966 10.01 7.72 25.425 20.829 40.19 38.216 34.8 41.024 48.333 85.251 39.157 127.943-4.94 22.949-12.606 43.288-19.386 61.231-16.54 43.844-25.65 68.011 2.966 108.808 54.965 78.38 36.214 163.261 26.137 194.935"
        }
      ></path>
    </svg>
  );
}

export default Xmlid7347Icon;
/* prettier-ignore-end */
